import { Navigate } from "react-router-dom";

export default function RecordingModeGate({ allowed, children }) {
  if (!allowed) {
    return <Navigate to="/home" replace />;
  }
  return children;
}
